module.exports = {
      id: "share-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#share-usage",
      toString: function () {
        return this.url;
      }
    }